module.exports = __webpack_public_path__ + "static/img/dinner6-big.ba414ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/dinner6-big.jpg
// module id = 453i
// module chunks = 0